import React from 'react';
import axios from 'axios';
import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import _ from 'lodash';

// import Autosuggest from 'react-autosuggest';

import ambiente from '../../config/ambienteConfig';
import { exibirMensagem } from '../../redux/actions/mensagemAction';


class MovimentacaoForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            tipo: 'REC',
            data_transacao: moment(),
            data_pagamento: moment(),
            descricao: '',
            valor: '',
            envolvido: '',
            conta_id: '',
            status: false,
            listaContas: [],
            redirecionar: false,
            continuar: false,
            suggestions: [],
            suggestionsInteressado: [],
        };
        this.debouncedLoadSuggestions = _.debounce(this.loadSuggestions, 1000);
    }

    componentDidMount = async () => {
        try {
            const resContas = await axios.get(`${ambiente.dev.server}/contas`);
            this.setState({ listaContas: resContas.data });
            this.setState({ conta_id: this.state.listaContas[0].id });
            //Obtendo o id da movimentação para o caso de um redirecionamento para alteração
            if (this.props.match.params.id) {
                const res = await axios.get(`${ambiente.dev.server}/transacoes/${this.props.match.params.id}`);
                let transacaoBanco = res.data;
                transacaoBanco.data_pagamento = moment(transacaoBanco.data_pagamento);
                transacaoBanco.data_transacao = moment(transacaoBanco.data_transacao);
                this.setState({ ...transacaoBanco });
            }
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    onSuggestionsFetchRequested = async ({ value }) => {
        this.debouncedLoadSuggestions(value);
    };

    loadSuggestions = async (value) => {
        const inputValue = value.trim().toLowerCase();
        if (inputValue.length === 0) return [];
        const res = await axios.get(`${ambiente.dev.server}/transacoes/search/desc?descricao=${inputValue}&tipo=${this.state.tipo}`);
        this.setState({ suggestions: res.data });
    };

    onSuggestionSelected = (evt, { suggestion }) => {
        this.setState({
            envolvido: suggestion.envolvido,
            conta_id: suggestion.conta_id,
            ccustos: suggestion.ccustos,
        });
    }

    renderSuggestion = suggestion => {
        return (
            <div>
                {suggestion.descricao} ({suggestion.envolvido})
            </div>
        );
    }

    onSuggestionsFetchRequestedInteressados = async ({ value }) => {
        const inputValue = value.trim().toLowerCase();
        if (inputValue.length === 0) return [];
        const res = await axios.get(`${ambiente.dev.server}/transacoes/search/envolvidos?nome=${inputValue}&tipo=${this.state.tipo}`);
        this.setState({ suggestionsInteressado: res.data });
    };

    renderSuggestionInteressado = suggestion => {
        return (
            <div>
                {suggestion.envolvido}
            </div>
        );
    }

    handleSelectMultiple = evt => {
        const arr = Array.prototype.slice.call(evt.target.selectedOptions).map(item => item.value);
        this.setState({ ccustos: arr });
    }

    handleSave = async () => {
        const movToSave = Object.assign({}, this.state);
        console.log(movToSave)
        movToSave.data_transacao = this.state.data_transacao.format('DD/MM/YYYY');
        movToSave.data_pagamento = this.state.data_pagamento.format('DD/MM/YYYY');
        delete movToSave.listaContas;
        delete movToSave.redirecionar;
        delete movToSave.continuar;
        delete movToSave.suggestions;
        delete movToSave.suggestionsInteressado;
        delete movToSave.id;

        try {
            if (this.state.parcelas > 1) movToSave.qtd_parcelas = this.state.parcelas;
            if (this.state.contaBilateralId) {
                movToSave.bilateral_conta_id = this.state.contaBilateralId;
                if (this.state.valorBilateral && this.state.valorBilateral > 0) movToSave.bilateral_valor = this.state.valorBilateral;
            }
            if (this.state.id) {
                await axios.put(`${ambiente.dev.server}/transacoes/${this.state.id}`, movToSave);
                this.props.exibirMensagem('yay', `Movimentação alterada com sucesso!`);
            } else {
                delete movToSave.formaAtualizacao;
                await axios.post(`${ambiente.dev.server}/transacoes`, movToSave);
                this.props.exibirMensagem('yay', `Movimentação inserida com sucesso!`);
            }
            if (!this.state.continuar) this.setState({ redirecionar: true });
        } catch (err) {
            this.props.exibirMensagem('err', `Erro: ${err}`);
        }
    }

    render() {
        if (this.state.redirecionar) return <Redirect to="/extrato" />;

        return (
            <div>
                <div className="row">
                    <div className="form-group col-3" data-toggle="buttons">
                        <button type="button" autoFocus onClick={() => this.setState({ tipo: 'REC' })} data-test="tipo-receita"
                            className={`btn btn-sm ${this.state.tipo === 'REC' ? 'btn-success active' : 'btn-secondary'}`} alt="Receita">
                            <i className="fas fa-thumbs-up" title="Receita" />
                        </button>
                        <button type="button" onClick={() => this.setState({ tipo: 'DESP' })} style={{ "marginTop": 0 }} data-test="tipo-despesa"
                            className={`btn btn-sm ${this.state.tipo === 'DESP' ? 'btn-danger active' : 'btn-secondary'}`} alt="Despesa">
                            <i className="fas fa-thumbs-down" title="Despesa" />
                        </button>
                    </div>
                    <div className="form-group col">
                        <input type="date" className="form-control" value={this.state.data_transacao.format('YYYY-MM-DD')} data-test="data-transacao" title="Data da transação"
                            onChange={evt => this.setState({ data_transacao: moment(evt.target.value, 'YYYY-MM-DD'), data_pagamento: moment(evt.target.value, 'YYYY-MM-DD') })} />
                    </div>
                    <div className="form-group col">
                        <input type="date" className="form-control" value={this.state.data_pagamento.format('YYYY-MM-DD')} data-test="data-pagamento" title="Data para pagamento"
                            onChange={evt => this.setState({ data_pagamento: moment(evt.target.value, 'YYYY-MM-DD') })} />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col-8">
                        <input type="text" placeholder="Descrição..." className="form-control" id="descricao" data-test="descricao" title="Descrição"
                            value={this.state.descricao} onChange={evt => this.setState({ descricao: evt.target.value })} />
                    </div>
                    <div className="form-group col-4">
                        <input type="number" step="0.01" placeholder="Valor" className="form-control" value={this.state.valor} data-test="valor" title="Valor"
                            onChange={evt => this.setState({ valor: evt.target.value })} />
                    </div>
                </div>
                <div className="row">
                    <div className="form-group col">
                        <input type="text" placeholder="Interessado..." className="form-control" id="envolvido" data-test="envolvido" title="Envolvido"
                            value={this.state.envolvido} onChange={evt => this.setState({ envolvido: evt.target.value })} />
                    </div>
                    <div className="form-group col">
                        <select className="form-control" value={this.state.conta_id} onChange={evt => this.setState({ conta_id: evt.target.value })} data-test="conta" aria-label="Conta">
                            {this.state.listaContas.map(item => <option key={item.id} value={item.id}>{item.nome}</option>)}
                        </select>
                    </div>
                    <div className="form-group col-2" data-toggle="buttons">
                        <button type="button" onClick={() => this.setState({ status: !this.state.status })} data-test="status"
                            className={`btn btn-sm btn-block ${this.state.status ? 'btn-success' : 'btn-outline-danger'}`}
                            title={this.state.status ? 'Conta Paga' : 'Conta Pendente'} >
                            <i className={`fas fa-${this.state.status ? 'check' : 'times'}`} alt={this.state.status ? 'Conta Paga' : 'Conta Pendente'} />
                        </button>
                    </div>
                </div>

                <button type="button" className="btn btn-block btn-primary" onClick={this.handleSave} alt="Salvar">
                    Salvar
                </button>

            </div>
        );
    }
}

MovimentacaoForm.propTypes = {
    exibirMensagem: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        exibirMensagem: (tipo, texto) => dispatch(exibirMensagem(tipo, texto))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MovimentacaoForm);



// WEBPACK FOOTER //
// ./src/components/movimentacao/MovimentacaoForm.js